import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import StickyHeader from "../../../../components/Layout/StickyHeader";
import ProgressIconGroup from "../../../../components/Service/Rent/ProgressIconGroup";

type Props = {};

export default function HistoryRentSuccess(props: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = location.state;

  return (
    <div>
      <StickyHeader
        title="대여하기"
        onBackClick={() => navigate(`/history/rent/${params.id}`)}
        className="px-5"
      />
      <div className="px-5 h-[370px] flex items-center justify-center">
        <div className="py-2.5 flex flex-col items-center h-full justify-evenly">
          <ProgressIconGroup step={1} />
          <div className="flex flex-col gap-2.5 items-center">
            <div className=" text-2xl font-semibold leading-[140%]">
              대여 완료
            </div>
            <div className=" text-sm leading-[18px] text-brand-neutral-70 whitespace-pre-line text-center">
              {
                "대여가 성공적으로 완료 되었어요.\n깨끗하게 사용하신 후 반납 부탁드려요"
              }
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 bg-[#f7f7f7] rounded-[3px]">
        <div className="flex justify-center pb-5">
          안내 사원에게 이 화면을 보여주세요
        </div>
      </div>
    </div>
  );
}
